/** Remove default focus outline on Spartan product interactive controls. */
export const SPARTAN_PRODUCT_OUTLINE_NONE_CLASS_NAME = 'outline-none';

/** Product page button corner radius (8px / `--radius-sm`). */
export const SPARTAN_PRODUCT_BUTTON_RADIUS_CLASS_NAME =
  'rounded-sm outline-none';

export const SPARTAN_PRODUCT_BUTTON_CLASS_NAME = 'rounded-sm px-4 outline-none';

/** Secondary product buttons — keep `before:` radius in sync with outline border. */
export const SPARTAN_PRODUCT_BUTTON_SECONDARY_CLASS_NAME =
  'rounded-sm px-4 before:rounded-sm outline-none';

export const SPARTAN_PRODUCT_ICON_BUTTON_CLASS_NAME =
  'size-10 shrink-0 rounded-sm p-2.5 before:rounded-sm outline-none';
